module.exports = __webpack_public_path__ + "static/media/2.d21f230d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2.jpg
// module id = 66
// module chunks = 0